module.exports = __webpack_public_path__ + "img/hanger.215886fa.svg";